import React, { useState, useEffect, ReactNode, FC } from 'react'
import { isString } from 'lodash'
import classNames from 'classnames'
import { Text } from 'components/ui-kit'

import './Checkbox.scss'

interface Props {
  className?: string
  isChecked?: boolean
  isDisabled?: boolean
  isMixed?: boolean
  isValid?: boolean
  onChange?: (state: boolean) => void
  textLabel?: ReactNode
  errorMessage?: string
}

export const Checkbox: FC<Props> = ({
  isChecked,
  onChange,
  isDisabled = false,
  isMixed = false,
  isValid = true,
  className,
  textLabel,
  errorMessage,
}) => {
  const [isInputChecked, setIsInputChecked] = useState(isChecked)

  useEffect(() => {
    if (isChecked !== isInputChecked) {
      setIsInputChecked(isChecked)
    }
  }, [isChecked, isInputChecked])

  const handleInputClick = () => {
    setTimeout(() => {
      const newCheckedState = isMixed ? false : !isInputChecked

      onChange(newCheckedState)
      setIsInputChecked(newCheckedState)
    })
  }

  return (
    <div
      className={classNames('checkbox', className, {
        mixed: isMixed,
        invalidated: !isValid && !isDisabled,
        checked: isInputChecked,
        disabled: isDisabled,
      })}>
      <label onClick={handleInputClick}>
        {/* @ts-ignore  ignore 'value' to leave old business logic working */}
        <input type="checkbox" value={isInputChecked} checked={isInputChecked} disabled={isDisabled} readOnly />
        {isString(textLabel) ? <Text type="paragraph">{textLabel}</Text> : textLabel}
      </label>
      {!isValid && !isDisabled && errorMessage && (
        <Text type="hint" className="error">
          {errorMessage}
        </Text>
      )}
    </div>
  )
}
